import { lazy, Suspense } from 'react'
import type { GraphNode, GraphLink } from '@/features/metrics/model/contracts'

const ForceGraph3D = lazy(() => import('react-force-graph-3d'))

interface ForceGraph3DWrapperProps {
  nodes: GraphNode[]
  links: GraphLink[]
  width: number
  height: number
  onNodeClick?: (node: GraphNode) => void
}

export function ForceGraph3DWrapper({
  nodes,
  links,
  width,
  height,
  onNodeClick,
}: ForceGraph3DWrapperProps) {
  const graphData = { nodes, links }

  function handleNodeClick(node: object) {
    const gn = node as GraphNode
    onNodeClick?.(gn)
  }

  return (
    <Suspense
      fallback={
        <div
          className="flex items-center justify-center text-xs text-muted-foreground"
          style={{ width, height }}
        >
          Loading 3D…
        </div>
      }
    >
      <ForceGraph3D
        graphData={graphData}
        width={width}
        height={height}
        nodeId="id"
        nodeLabel="label"
        nodeColor={(node) => {
          const gn = node as GraphNode
          return gn.color ?? '#888'
        }}
        nodeVal={(node: object) => {
          const gn = node as GraphNode
          return 1 + Math.sqrt(gn.influence ?? 0) * 0.5
        }}
        linkColor={() => 'rgba(150,150,200,0.3)'}
        linkWidth={(link: object) => {
          const l = link as GraphLink
          return 0.3 + (l.weight / 10) * 0.8
        }}
        onNodeClick={handleNodeClick}
        backgroundColor="rgba(0,0,0,0)"
        showNavInfo={false}
      />
    </Suspense>
  )
}
